import classnames from 'classnames'
import React from 'react'

import { decodeQueryString, encodeQueryString } from '../queryString'
import MenuNew from './components/redesign/Menu'
import { CURRENCIES_LIST, getActiveCurrency } from './currencyUtils'
import Menu from './menu'
import { PageType } from './types'

function CryptoMaps() {
  var currencies = {
    active: getActiveCurrency(decodeQueryString()),
    currencies: CURRENCIES_LIST,
    link: (activeCurrency: string) =>
      '/crypto_maps.ashx?' + encodeQueryString({ ...decodeQueryString(), t: undefined, c: activeCurrency }),
  }

  const isRedesignEnabled = FinvizSettings.hasRedesignEnabled
  const MenuComponent = isRedesignEnabled ? MenuNew : Menu

  return (
    <div
      className={classnames('forex flex-col', {
        futures: !isRedesignEnabled,
      })}
    >
      <div className={classnames('mx-auto', isRedesignEnabled && 'max-w-[79rem]')}>
        <MenuComponent activePage={PageType.Maps} currencies={currencies} />
      </div>
    </div>
  )
}

export default CryptoMaps
